import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CoachCheckout from 'components/coachSalesPages/CoachCheckout';

function mapStateToProps(state, ownProps) {
  const { paymentReducer, analyticsReducer } = state;
  return {
    onboardingGoalOptions: paymentReducer.get('onboardingGoalOptions') || [],
    planOptions: paymentReducer.get('plans'),
    extraPlanOptions: paymentReducer.get('extraPlans'),
    extraBenefits: paymentReducer.get('extraBenefits'),
    logo: paymentReducer.get('logo'),
    stripePubKey: paymentReducer.get('stripePubKey'),
    siteCheckout: paymentReducer.get('siteCheckout'),
    landingPageCustomizations: paymentReducer.get('landingPageCustomizations'),
    productName: paymentReducer.get('productName'),
    checkoutMethod: paymentReducer.get('checkoutMethod'),
    accessType: paymentReducer.get('accessType'),
    customCheckoutSuccessURL: paymentReducer.get('customCheckoutSuccessURL'),
    temp_hana_checkoutMethod: paymentReducer.get('temp_hana_checkoutMethod'),
    payPalBackupMessage: paymentReducer.get('payPalBackupMessage'),
    coachName: analyticsReducer.get('coachName')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch),
      signUpActions: bindActionCreators(require('actions/signUpActions'), dispatch),
      analyticsActions: bindActionCreators(require('actions/analyticsActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CoachCheckout);


// WEBPACK FOOTER //
// ./src/containers/CoachCheckoutContainer.js